import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Input,
  Loader,
  LoadingOverlay,
  NumberFormatter,
  rem,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import {
  IconActivity,
  IconCheck,
  IconEdit,
  IconEye,
  IconFileText,
  IconFileTypeCsv,
  IconFileUpload,
  IconHandStop,
  IconRefresh,
  IconSearch,
  IconTrash,
  IconUsers,
  IconWindow,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useEffect, useState } from "react";

import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconPhone } from "@tabler/icons-react";
import * as xlsx from "xlsx";
import * as XLSX from "xlsx";
import {
  _timerDelayClick,
  repositoryMdm,
  repositoryPos,
} from "../../_base/_const/_constVar";
import _breadcrumb from "../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { paginationBase } from "../../_base/model/_base/BaseTable";
import { AvatarUtils } from "../../common/ColorByName/AvatarUtils";
import { formatDateTransfer } from "../../common/FormatDate/FormatDate";
import { _localization } from "../../config/location";
import { cobalt_blue, green } from "../../const/variables";
import { MessageResponse } from "../../model/MessageResponse";
import { TblDebtGroup } from "../../model/TblDebtGroup";
import CreateDataView from "./CreateDataView";
import DetailDataView from "./DetailDataView";
import DropZoneFile from "./DropZoneFile";
import EditDataView from "./EditDataView";
import { getTblDmEmployeeAll } from "../../service/getSelectApi";
import { getValueById } from "../../_base/helper/FunctionHelper";

const DebtGroupListCus = ({ type }: DebtGroupListCusProps) => {
  //#region State
  //data and fetching state
  const headerRef = React.useRef<HTMLDivElement>(null);
  // @ts-ignore
  const [data, setData] = useState<TblDebtGroup[]>([]);
  const [dataTemp, setDataTemp] = useState<TblDebtGroup[]>([]);
  const [dataReview, setDataReview] = useState<TblDebtGroup[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [visible, { toggle, open, close }] = useDisclosure(false);

  //table state
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});

  // const [keySearch, setKeySearch] = useState<string>("");
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const [pagination, setPagination] = useState(paginationBase);

  //data
  const [dataEmployee, setDataEmployee] = useState<any[]>([]);

  //count
  const [timeLeft, setTimeLeft] = useState(60);
  const [isCounting, setIsCounting] = useState(false);
  const [search, setSearch] = useState({
    keySearch: "",
    Phone: "",
    TaxCode: "",
    Code: "",
  });

  function getColorStatus(text: boolean) {
    switch (text) {
      case true:
        return "teal";
      default:
        return "red";
    }
  }

  // Grid span
  const gridSpan = { base: 12, sm: 4, md: 4, lg: 4, xl: 4 };

  //#region  table
  const columns = React.useMemo<MRT_ColumnDef<TblDebtGroup>[]>(
    () => [
      {
        accessorKey: "groupCode",
        header: "Mã nhóm công nợ",
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label="Xem chi tiết">
            <Badge
              radius="sm"
              variant="dot"
              size="lg"
              style={{ cursor: "pointer" }}
              color={renderedCellValue === null ? "red" : green.base}
              onDoubleClick={() => detailItem(row.original.id)}
            >
              {renderedCellValue === null ? null : renderedCellValue}
            </Badge>
          </Tooltip>
        ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        size: 250,
      },
      {
        accessorKey: "active",
        header: "Trạng thái",
        Cell: ({ renderedCellValue, row }) => (
          <>
            <Badge color={getColorStatus(row.original.active ?? false)}>
              {row.original.active ? "Đang hoạt động" : "Dừng hoạt động"}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "groupName",
        header: "Tên nhóm",
        Cell: ({ renderedCellValue }: any) => (
          <Text size="12.5px" fw={"bold"}>
            {renderedCellValue}
          </Text>
        ),
        size: 550,
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "taxCode",
        header: "Mã số thuế",
        Cell: ({ renderedCellValue }: any) => (
          <Text size="12.5px">
            {renderedCellValue === null ? "Không tồn tại" : renderedCellValue}
          </Text>
        ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "address",
        header: "Địa chỉ",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "phone",
        header: "Điện thoại",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "contactPerson",
        header: "Người giao dịch",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "classification",
        header: "Phân loại",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "classificationName",
        header: "Tên phân loại",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "debtTerm",
        header: "Thời hạn nợ",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "debtLimit",
        header: "Giới hạn nợ",
        Cell: ({ renderedCellValue }: any) => (
          <NumberFormatter
            thousandSeparator={","}
            value={renderedCellValue}
          ></NumberFormatter>
        ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "createBy",
        header: "Người tạo",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text fw={500} size="12.5px">
              {getValueById(String(renderedCellValue), dataEmployee, "label")}
            </Text>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "lastCreateByName",
        header: "Người cập nhật gần nhất",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }) => (
          <AvatarUtils value={renderedCellValue?.toString() ?? ""} />
        ),
      },
      {
        accessorKey: "lastUpdateDate",
        header: "Thời gian cập nhật gần nhất",
        size: 200,
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        enableResizing: false,
        size: 130,
        Cell: ({ renderedCellValue, row, table }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Tooltip label="Chỉnh sửa">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="orange"
                onClick={async () => {
                  editItem(row.original.id);
                }}
              >
                <IconEdit size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>

            <Tooltip
              label={
                row.original.active === true ? "Dừng hoạt động" : "Hoạt động"
              }
            >
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color={row.original.active === true ? "violet" : "green"}
                onClick={async () => {
                  await handleActive(
                    row.original.id.toString(),
                    !row.original.active,
                  );
                }}
              >
                {row.original.active === true ? (
                  <IconHandStop size={20} />
                ) : (
                  <IconActivity size={20} />
                )}
              </ActionIcon>
            </Tooltip>

            <Tooltip label="Xóa">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="red"
                onClick={async () => {
                  openModalPaymentBase(row.original.id, false);
                }}
              >
                <IconTrash size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>

            <Tooltip label="Chi tiết">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="cyan"
                onClick={async () => {
                  detailItem(row.original.id);
                }}
              >
                <IconEye size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Box>
        ),
      },
    ],
    [dataEmployee],
  );

  const startCountdown = () => {
    if (!isCounting) {
      setTimeLeft(_timerDelayClick);
      setIsCounting(true);
    }
  };

  const handleImportExcel = async (file: any) => {
    if (!file) {
      NotificationExtension.Warn("Vui lòng chọn lại tệp !");
      return;
    } else {
      modals.closeAll();
      NotificationExtension.Success("Import excel thành công !");
    }

    const fileReader = new FileReader();
    fileReader.onload = async (e) => {
      const data = e.target?.result;
      if (data) {
        const workbook = xlsx.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        let worksheet = workbook.Sheets[sheetName];
        worksheet = xlsx.utils.sheet_add_aoa(
          worksheet,
          [
            [
              "groupCode",
              "groupName",
              "taxCode",
              "address",
              "phone",
              "contactPerson",
              "classification",
              "classificationName",
              "debtTerm",
              "debtLimit",
            ],
          ],
          { origin: "A1" },
        );
        const jsonData = xlsx.utils.sheet_to_json(worksheet);
        const dataSubmit = jsonData?.map((item: any, index) => ({
          id: "0",
          active: item.active,
          groupCode: item.groupCode,
          groupName: item.groupName,
          taxCode: item.taxCode?.toString(),
          address: item.address,
          phone: item.phone?.toString(),
          contactPerson: item.contactPerson,
          classification: item.classification,
          classificationName: item.classificationName,
          debtTerm: Number(item.debtTerm?.toString().replace(/\s+/g, "")) || 0,
          debtLimit:
            Number(item.debtLimit?.toString().replace(/\s+/g, "")) || 0,
          type: type,
        }));
        setDataReview(dataSubmit);
        setTimeout(() => {
          reviewDataImport();
        }, 1000);
      }
    };
    fileReader.readAsBinaryString(file);
  };

  const handleOpenFileDrop = () => {
    try {
      modals.openConfirmModal({
        title: null,
        yOffset: "5%",
        withCloseButton: false,
        children: <DropZoneFile onImport={handleImportExcel}></DropZoneFile>,
        confirmProps: { display: "none" },
        cancelProps: { display: "none" },
      });
    } catch (e) {
      NotificationExtension.Fails("Import excel thất bại");
    }
  };

  const handleChangeSearchValue = (value: string, key: string) => {
    setSearch((prevData) => ({ ...prevData, [key]: value }));
  };

  const createListDebtGroup = async () => {
    try {
      if (dataReview.length > 0) {
        const response = await repositoryPos.post(
          "/api/v1/TblDebtGroup/create-list",
          dataReview,
        );
        if (response?.success) {
          NotificationExtension.Success("Tạo mới thành công!");
          modals.closeAll();
        }
      } else {
        NotificationExtension.Warn("Vui lòng thêm nhóm công nợ!");
      }
    } catch (e) {
      console.error(e);
      return;
    }
  };

  const fetchData = async (isExportExcel?: boolean) => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);

    let url = `?Type=${type}&Skip=${
      pagination?.pageIndex * pagination?.pageSize
    }&Take=${pagination.pageSize}`;

    if (search.keySearch) {
      url += `&KeySearch=${search.keySearch}`;
    }
    if (search.Code) {
      url += `&Code=${search.Code}`;
    }
    if (search.TaxCode) {
      url += `&TaxCode=${search.TaxCode}`;
    }
    if (search.Phone) {
      url += `&Phone=${search.Phone}`;
    }

    try {
      const response = await repositoryPos.get(
        `/api/v1/TblDebtGroup/get-list${url}`,
      );

      if (response && response.success) {
        let result = response?.data;

        if (isExportExcel) {
          open();
          handleExportExcel(response?.totalCount || 0);
        } else {
          setData(result);
          setDataTemp(result);
          setRowCount(response?.totalCount);
          setSelectIds([]);
          table.resetRowSelection();
        }
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
    startCountdown();
  };

  const handleExportExcel = async (totalCount: number) => {
    open();
    try {
      // ... (Giữ nguyên phần logic lấy URL và gọi API của bạn)
      let url = `?Type=${type}&Skip=0&Take=${totalCount}`;
      if (search.keySearch) url += `&KeySearch=${search.keySearch}`;
      if (search.Code) url += `&Code=${search.Code}`;
      if (search.TaxCode) url += `&TaxCode=${search.TaxCode}`;
      if (search.Phone) url += `&Phone=${search.Phone}`;

      const res = await repositoryPos.get<MessageResponse<any>>(
        `/api/v1/TblDebtGroup/get-list${url}`,
      );

      if (res && res.success) {
        const result = res.data;
        const dataExport = result.map((i: any) => ({
          "Mã nhóm công nợ": i.groupCode || "",
          "Trạng thái":
            i.active === true
              ? "Đang hoạt động"
              : i.active === false
                ? "Dừng hoạt động"
                : "",
          "Tên nhóm": i.groupName || "",
          "Mã số thuế": i.taxCode || "",
          "Địa chỉ": i.address || "",
          "Điện thoại": i.phone || "",
          "Người giao dịch": i.contactPerson || "",
          "Phân loại": i.classification || "",
          "Tên phân loại": i.classificationName || "",
          "Thời hạn công nợ": i.debtTerm || "",
          "Hạn mức công nợ":
            i.debtLimit || i.debtLimit === 0
              ? Number(i.debtLimit).toLocaleString()
              : "",
          "Người cập nhật gần nhất": i.lastCreateByName || "",
          "Thời gian cập nhật gần nhất": i.lastUpdateDate
            ? formatDateTransfer(i.lastUpdateDate)
            : "",
        }));

        // 1. Tạo worksheet
        const worksheet = XLSX.utils.json_to_sheet(dataExport);

        // 2. Tự động tính độ rộng cột (AutoFit)
        const objectMaxLength: any[] = [];
        dataExport.forEach((row: any) => {
          Object.keys(row).forEach((key, index) => {
            const value = row[key] ? row[key].toString() : "";
            const columnWidth = value.length;

            // So sánh độ dài tên cột và độ dài dữ liệu
            const headerWidth = key.length;
            const finalWidth = Math.max(headerWidth, columnWidth);

            objectMaxLength[index] = {
              wch: Math.min(finalWidth + 5, 50), // Cộng thêm padding và giới hạn tối đa 50 ký tự
            };
          });
        });
        worksheet["!cols"] = objectMaxLength;

        // 4. Xuất file
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          workbook,
          worksheet,
          "Danh sách đối tượng công nợ",
        );
        XLSX.writeFile(workbook, "Danh_sach_doi_tuong_cong_no.xlsx");
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const fetchDataEmp = async () => {
    const res = await getTblDmEmployeeAll();

    if (res) {
      const data = res
        .filter((item) => item.id && item.fullname)
        .map((item) => ({
          label: `${item.code} - ${item.fullname}`,
          value: String(item.id),
        }));
      setDataEmployee(data);
    }
  };

  function createItem() {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Tạo mới nhóm công nợ!</Title>
        </>
      ),
      size: "auto",
      children: <CreateDataView type={type} onClose={setDeleteViewStatus} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  const handleActive = async (id: string, active: boolean) => {
    try {
      const response = await repositoryPos.post("/api/v1/TblDebtGroup/active", {
        ids: [id],
        active: active,
      });

      if (response?.success) {
        NotificationExtension.Success("Cập nhật trạng thái thành công!");
        await fetchData();
      } else {
        NotificationExtension.Fails("Cập nhật trạng thái thất bại!");
      }
    } catch (error) {
      console.error("Lỗi khi gọi API TblDebtGroup/active:", error);
      NotificationExtension.Fails("Có lỗi xảy ra khi cập nhật trạng thái!");
    }
  };

  const handleDelete = async (id: string) => {
    try {
      const response = await repositoryPos.post("/api/v1/TblDebtGroup/delete", {
        ids: [id],
      });

      if (response?.success) {
        NotificationExtension.Success("Xóa thành công!");
        await fetchData();
      } else {
        NotificationExtension.Fails("Xóa thất bại!");
      }
    } catch (error) {
      console.error("Lỗi khi gọi API TblDebtGroup/active:", error);
      NotificationExtension.Fails("Có lỗi xảy ra khi Xóa!");
    }
  };

  const handleAsyncDebt = async () => {
    open();
    try {
      const res = await repositoryMdm.post<MessageResponse<any>>(
        "/api/v1/SyncData/sync-data-debt-group",
      );

      if (res && res.success) {
        NotificationExtension.Success(
          res.message || "Đồng bộ công nợ thành công !",
        );

        setTimeout(() => {
          fetchData();
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const openModalPaymentBase = async (id: string, active: boolean) => {
    modals.openConfirmModal({
      title: <Title order={5}>Xác nhận xóa</Title>,
      children: (
        <>
          <Flex justify={"end"} gap={20} mt={"sm"}>
            <Button
              color="gray"
              leftSection={<IconWindow size={18} />}
              onClick={() => {
                modals.closeAll();
              }}
            >
              Huỷ
            </Button>
            <Button
              leftSection={<IconCheck size={18} />}
              onClick={() => {
                handleDelete(id);
                modals.closeAll();
              }}
            >
              Xác nhận
            </Button>
          </Flex>
        </>
      ),
      labels: { confirm: "Confirm", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      size: "400px",
      classNames: {
        title: "custom-modal-title",
        body: "custom-modal-body",
      },
    });
  };

  function editItem(id: string | number) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Sửa nhóm công nợ!</Title>
        </>
      ),
      size: "auto",
      children: (
        <EditDataView id={id} type={type} onClose={setDeleteViewStatus} />
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function detailItem(id: string | number) {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xem chi tiết nhóm công nợ!</Title>
        </>
      ),
      size: "auto",
      children: <DetailDataView id={id} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  function reviewDataImport() {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xem lại danh sách nhóm công nợ!</Title>
        </>
      ),
      size: "auto",
      children: <MantineReactTable table={tableReview} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  }

  useEffect(() => {
    let timer: ReturnType<typeof setInterval>;
    if (isCounting && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setIsCounting(false);
    }
    return () => clearInterval(timer);
  }, [isCounting, timeLeft]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    if (pagination.pageIndex === 0 && data.length < pagination.pageSize) {
      fetchData();
    } else {
      fetchData();
    }
  }, [pagination.pageIndex, pagination.pageSize]);

  useEffect(() => {
    fetchData();
  }, [deleteViewStatus]);

  useEffect(() => {
    fetchDataEmp();
  }, []);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 160 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (210 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, [height]);

  const tableReview = useMantineReactTable({
    columns,
    data: dataReview,
    positionToolbarAlertBanner: "bottom",
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    renderBottomToolbar: (
      <>
        <Flex w={"100%"} my={"10px"} pr={"20px"} justify={"flex-end"}>
          <Button
            onClick={() => {
              createListDebtGroup();
            }}
          >
            Tạo mới
          </Button>
        </Flex>
      </>
    ),
    localization: _localization,
    enableRowSelection: true,
    initialState: {
      columnPinning: {
        left: ["mrt-row-select", "groupCode"],
      },
      showColumnFilters: false,
      columnVisibility: { id: false, action: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "normal",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    onPaginationChange: setPagination,
    state: {
      isLoading,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: false,
      withEdges: true,
    },
    // paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: true,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });

  const table = useMantineReactTable({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    enableColumnResizing: true,
    //add custom action buttons to top-left of top toolbar
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },

    localization: _localization,
    enableRowSelection: true,
    getRowId: (row) => row.id,
    initialState: {
      columnPinning: {
        left: ["mrt-row-select", "groupCode"],
        right: ["action"],
      },
      showColumnFilters: false,
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height + 50, minHeight: height + 50 },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    // onColumnFiltersChange: setColumnFilters,
    // onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    // onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        //  fontWeight: row.getIsSelected() ? "bold" : "normal", //conditional styling
        fontWeight: "normal", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      //sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    // mantinePaginationProps: {
    //   showRowsPerPage: true,
    //   withEdges: f,
    // },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: true,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });
  //#endregion
  return (
    <>
      <>
        <div
          ref={headerRef}
          style={{
            width: "100%",
          }}
        >
          <LoadingOverlay
            visible={visible}
            zIndex={1000}
            overlayProps={{ radius: "sm", blur: 5 }}
            loaderProps={{
              children: (
                <Flex direction={"column"} align="center" gap="xs">
                  <Loader type="dots" size={35}></Loader>
                  {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                  <Title size={15}> Đang xử lý....</Title>
                </Flex>
              ),
            }}
          />
          <Flex
            gap="md"
            justify="space-between"
            align="center"
            direction="row"
            wrap="wrap"
          >
            <_breadcrumb></_breadcrumb>
            <Flex gap={"sm"}>
              <Button
                leftSection={
                  <IconRefresh style={{ width: rem(14), height: rem(14) }} />
                }
                onClick={() => handleAsyncDebt()}
              >
                Đồng bộ công nợ
              </Button>
              <Button
                leftSection={
                  <IconFileUpload style={{ width: rem(14), height: rem(14) }} />
                }
                onClick={() => handleOpenFileDrop()}
              >
                Import Excel
              </Button>
              <Button
                leftSection={
                  <IconFileTypeCsv
                    style={{ width: rem(14), height: rem(14) }}
                  />
                }
                onClick={() => fetchData(true)}
              >
                Export Excel
              </Button>
            </Flex>
          </Flex>
          <Grid>
            <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
              <Input
                flex={1}
                placeholder="Nhập từ khóa tìm kiếm"
                type="text"
                w={"100%"}
                leftSection={
                  <IconSearch size={"20"} color={cobalt_blue.base}></IconSearch>
                }
                onChange={(e) => {
                  handleChangeSearchValue(e.target.value ?? "", "keySearch");
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    fetchData();
                  }
                }}
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
              <Input
                flex={1}
                placeholder="Nhập mã nhóm công nợ"
                type="text"
                w={"100%"}
                leftSection={
                  <IconUsers size={"20"} color={cobalt_blue.base}></IconUsers>
                }
                onChange={(e) => {
                  handleChangeSearchValue(e.target.value ?? "", "Code");
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    fetchData();
                  }
                }}
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
              <Input
                flex={1}
                placeholder="Nhập mã số thuế"
                type="text"
                w={"100%"}
                leftSection={
                  <IconFileText
                    size={"20"}
                    color={cobalt_blue.base}
                  ></IconFileText>
                }
                onChange={(e) => {
                  handleChangeSearchValue(e.target.value ?? "", "TaxCode");
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    fetchData();
                  }
                }}
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
              <Input
                flex={1}
                placeholder="Nhập số điện thoại"
                type="text"
                w={"100%"}
                leftSection={
                  <IconPhone size={"20"} color={cobalt_blue.base}></IconPhone>
                }
                onChange={(e) => {
                  handleChangeSearchValue(e.target.value ?? "", "Phone");
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    fetchData();
                  }
                }}
              />
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
              <Button
                leftSection={<IconSearch size={14} />}
                color="blue"
                variant="outline"
                onClick={async () => {
                  await fetchData();
                }}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>
        </div>
        <Box mt={10}>
          <MantineReactTable table={table} />
        </Box>
      </>
    </>
  );
};

type DebtGroupListCusProps = {
  type: number;
};

export default DebtGroupListCus;
